import { MARKETING_NAV_CONFIG } from '../../../data'
import { MenuItemData } from '../menu-item-data'
import { useMemo } from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'

export const useMarketingMenuData = (): MenuItemData[] => {
  return useMemo(
    () =>
      MARKETING_NAV_CONFIG.desktop.map(slice => {
        if (slice.items?.length) {
          return {
            isDense: slice.isDense,
            label: slice.label,
            columns: slice.columns,
            submenuItems: slice.items?.map(link => ({
              fullWidth: link.fullWidth,
              label: link.label,
              isExternal: link.isExternal ?? false,
              description: link.label_subtext,
              href: link.link ?? '',
              sendEvent: () => events.Global_MarketingNav_Clicked_DropdownLink(link.label)
            })),
            sendEvent: () => events.Global_MarketingNav_Clicked_DropdownMenu(slice.label)
          }
        } else {
          return {
            label: slice.label,
            href: slice.link ?? '',
            isExternal: slice.isExternal,
            sendEvent: () => events.Global_MarketingNav_Clicked_NavLink(slice.label)
          }
        }
      }),
    []
  )
}
